import(/* webpackMode: "eager" */ "/app/src/app/[locale]/padlev/page.tsx");
